import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import s from './AddBlockModal.scss'
import {
  TextEditor,
  InputContainer,
  PricingTable,
  PricingTableSimple_V1,
  PricingTableSimple_V2
} from 'components/ideal-core-ui'
import Select from 'react-select'

const AddBlockModal = ({
  setIsAddBlockModalVisible,
  isAddBlockModalVisible,
  setBlock,
  block,
  resetBlock,
  saveBlock,
  fromTemplate,
  categoryList
}) => {
  const closeModal = () => {
    setIsAddBlockModalVisible(!isAddBlockModalVisible)
    resetBlock()
  }
  return (
    <>
      <Modal
        keyboard={false}
        backdrop="static"
        isOpen={isAddBlockModalVisible}
        size="xl"
        className={s.modal}
      >
        <ModalHeader className={s.modalHeader}>{block.id ? 'Edit Block' : 'Add Block'}</ModalHeader>
        <ModalBody className={s.modalBody}>
          {!fromTemplate && (
            <div className={s.additionalFieldsWrapper}>
              <InputContainer
                type="text"
                style={{
                  display: 'inline'
                }}
                placeholder="Block Name"
                cb={value =>
                  setBlock(draft => {
                    draft.name = value
                  })
                }
                text={block.name}
                classname={s.title}
              />
              <Select
                placeholder="Block Category"
                onChange={value =>
                  setBlock(draft => {
                    draft.category = value
                  })
                }
                options={categoryList}
                className={s.select}
                value={block.category}
                isDisabled={block.type === 'PRICING_TABLE'}
                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                menuPortalTarget={document.body}
              />
              <div className={s.radioGroup}>
                <label>Visible</label>
                <input
                  type="radio"
                  checked={block.visible === 'everyone'}
                  onChange={() =>
                    setBlock(draft => {
                      draft.visible = 'everyone'
                    })
                  }
                />{' '}
                Everyone in my org
                <input
                  type="radio"
                  checked={block.visible === 'me'}
                  onChange={() =>
                    setBlock(draft => {
                      draft.visible = 'me'
                    })
                  }
                  className={s.rightRadio}
                />{' '}
                Just me
              </div>
            </div>
          )}
          {block.type === 'PRICING_TABLE' ? (
            (() => {
              switch (block.subType) {
                case 'SIMPLE_PRICING_TABLE_V1':
                  return (
                    <PricingTableSimple_V1
                      content={block.content}
                      actions={[
                        {
                          text: 'Save',
                          cb: block => {
                            saveBlock(block)
                          },
                          className: s.saveBtn
                        },
                        {
                          text: 'Cancel',
                          cb: () => closeModal()
                        }
                      ]}
                    />
                  )
                case 'SIMPLE_PRICING_TABLE_V2':
                  return (
                    <PricingTableSimple_V2
                      content={block.content}
                      actions={[
                        {
                          text: 'Save',
                          cb: block => {
                            saveBlock(block)
                          },
                          className: s.saveBtn
                        },
                        {
                          text: 'Cancel',
                          cb: () => closeModal()
                        }
                      ]}
                    />
                  )
                default:
                  return (
                    <PricingTable
                      content={block.content}
                      actions={[
                        {
                          text: 'Save',
                          cb: block => {
                            saveBlock(block)
                          },
                          className: s.saveBtn
                        },
                        {
                          text: 'Cancel',
                          cb: () => closeModal()
                        }
                      ]}
                    />
                  )
              }
            })()
          ) : (
            <TextEditor
              template={block.content}
              actions={[
                {
                  text: 'Save',
                  cb: (block, title, subject, destroyEditor) => {
                    saveBlock(block, destroyEditor)
                  },
                  className: s.saveBtn,
                  enabled: block.name && block.category
                },
                {
                  text: 'Cancel',
                  cb: (block, title, subject, destroyEditor) => {
                    destroyEditor && destroyEditor()
                    closeModal()
                  }
                }
              ]}
            />
          )}
        </ModalBody>
      </Modal>
    </>
  )
}

export default AddBlockModal
